import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import FolderGeneralInfoContainer from '../info/components/FolderGeneralInfoContainer';
import FinancedOffersContainer from '../financedOffers/components/FinancedOffersContainer';
import FolderCommentsCardContainer from 'features/folder/edit/comments/components/FolderCommentsCardContainer';
import { RightsContext } from 'providers/RightsContext';

const FolderGeneralDataContainer = ({ documentId, siteId, history, isFacilityApproval, documentTypeId, masterPartnerApp }) => {
  const { folderGeneralInfoRead } = useContext(RightsContext);
  return (
    <>
      {folderGeneralInfoRead && (
        <FolderGeneralInfoContainer
          documentId={documentId}
          siteId={siteId}
          isFacilityApproval={isFacilityApproval}
          history={history}
          documentTypeId={documentTypeId}
        />
      )}
      <FinancedOffersContainer
        documentId={documentId}
        siteId={siteId}
        displayAssociatedPartners={true}
        masterPartnerApp={masterPartnerApp}
      />
      {documentId && <FolderCommentsCardContainer documentId={documentId} siteId={siteId} />}
    </>
  );
};

FolderGeneralDataContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  history: PropTypes.object,
  isFacilityApproval: PropTypes.bool,
  masterPartnerApp: PropTypes.bool,
  documentTypeId: PropTypes.number
};

export default FolderGeneralDataContainer;
